// getLivestreamChannelsHealth.js
'use strict';
import { getSocket } from '../serviceWorker/pusher.js';

/**
 * Read subscription state of the given Pusher channel names straight from the
 * tab-local socket.
 * @param {object} params
 * @param {string[]} [params.channelNames] - channel names to inspect.
 * @returns {Object<string, {exists: boolean, subscribed: boolean, subscriptionPending: boolean, subscriptionCancelled: boolean}>}
 * @example
 * getLivestreamChannelsHealth({ channelNames: ['private-enc-stream@A'] });
 * // => { 'private-enc-stream@A': { exists: true, subscribed: true, subscriptionPending: false, subscriptionCancelled: false } }
 */
const getLivestreamChannelsHealth = ({ channelNames = [] } = {}) => {
  const channels = getSocket()?.channels?.channels || {};
  return channelNames.reduce((accumulated, channelName) => {
    const channel = channels[channelName];
    accumulated[channelName] = {
      exists: !!channel,
      subscribed: !!channel?.subscribed,
      subscriptionPending: !!channel?.subscriptionPending,
      subscriptionCancelled: !!channel?.subscriptionCancelled,
    };
    return accumulated;
  }, {});
};

export default getLivestreamChannelsHealth;
